import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../utils/createScopedI18n';
import { companyI18n } from '../../views/Configuration/pages/Company/i18n';
import './branchCard.scss';

export default function BranchCard({
  DesignSystemComponents,
  branch,
  isEditable = true,
  onEdit,
  onDelete,
  isModifyBranch = true,
}) {
  const { language } = useLanguage();
  const companyLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: companyI18n });
  const { Badge, IconButton, SvgIcon, Card } = DesignSystemComponents;

  useEffect(() => {
    companyI18n.changeLanguage(companyLanguage);
  }, [companyLanguage]);

  return (
    <Card specialPadding='p-3'>
      <div className='branch-container d-flex'>
        <div className='me-2 branch-icon-container d-flex align-items-center'>
          <SvgIcon name='building2' size='24px' stroke='var(--primary-500)' />
        </div>

        <div className='d-flex justify-content-between w-100'>
          <div className='gap-1 d-flex flex-column'>
            <div className='d-flex gap-2 align-items-center mb-1'>
              <p className='fw-semibold'>{branch.name}</p>
              {branch.isMain && (
                <Badge
                  autoWidth
                  color='info'
                  size='sm'
                  text={t('company_branchCard_main')}
                />
              )}
            </div>

            <div className='caption font-light d-flex align-items-center gap-2'>
              <SvgIcon size='16px' name='geoAlt' />
              <span className={!branch.address ? 'color-gray-600 fw-' : ''}>
                {branch.address || t('company_branchCard_notRegistered')}
              </span>
            </div>

            <p className='caption font-light'>
              {t('company_branchCard_phone')}{' '}
              <span className={!branch.phone ? 'color-gray-600 fw-light' : ''}>
                {branch.phone || t('company_branchCard_notRegistered')}
              </span>
            </p>

            <p className='caption font-light'>
              {t('company_branchCard_email')}{' '}
              <span className={!branch.email ? 'color-gray-600 fw-light' : ''}>
                {branch.email || t('company_branchCard_notRegistered')}
              </span>
            </p>
          </div>

          <div className='d-flex gap-2'>
            {isModifyBranch && (
              <IconButton
                ariaLabel={t('company_branchCard_editAria')}
                icon='pencil'
                onClick={() => onEdit?.(branch)}
                size='md'
                iconStroke='var(--primary-500)'
              />
            )}

            {isEditable && (
              <IconButton
                ariaLabel={t('company_branchCard_deleteAria')}
                icon='trash'
                onClick={() => onDelete?.(branch)}
                size='md'
                iconStroke='var(--error-500)'
              />
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
